export default __webpack_public_path__ + "static/media/washing-machine.1dc4c12d.png";